import { gql } from '@apollo/client'

export const CREATE_ZAI_SOA_QUESTION_MUTATION = gql`
  mutation CreateZaiSoaQuestion(
    $brandContext: [ZaiBrandContext!]!
    $category: String!
    $filterContext: CreateZaiShareMessageContext!
    $language: TaxonomyLanguages!
    $message: String!
  ) {
    createZaiSoaQuestion(
      input: {
        brandContext: $brandContext
        category: $category
        filterContext: $filterContext
        language: $language
        message: $message
      }
    ) {
      id
      message
    }
  }
`
